module.exports = __webpack_public_path__ + "static/media/absg_logo.ddc210b5.svg";